'use client'

import { useState } from 'react'

import { Screen } from 'constants/tracking/screens'
import { useConversationContext } from '@marketplace-web/domain/core-conversation'
import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/domain/conversation-action'

import MarkAsDeliveredToSenderConfirmationModal from '../MarkAsDeliveredToSenderConfirmationModal'

type Props = ConversationActionProps

const MarkAsReturnedToSender = ({ primary, title, inverse, theme, size }: Props) => {
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id

  const [isModalOpen, setIsModalOpen] = useState(false)

  function handleButtonClick() {
    setIsModalOpen(true)
  }

  function handleCloseModal() {
    setIsModalOpen(false)
  }

  if (!transactionId) return null

  return (
    <>
      <ConversationActionButton
        text={title}
        primary={primary}
        size={size}
        theme={theme}
        inverse={inverse}
        onClick={handleButtonClick}
      />
      <MarkAsDeliveredToSenderConfirmationModal
        transactionId={transactionId}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        screen={Screen.MessageReply}
      />
    </>
  )
}

export default MarkAsReturnedToSender
